import { FormControlLabel, styled } from '../../../../../base';

export const FilterContainer = styled('div')(({ theme }) => ({
    margin: theme.spacing(2, 0),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3, 2),
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    margin: 0,
    alignItems: 'flex-start',
    '.MuiFormControlLabel-label': {
        marginInlineEnd: theme.spacing(1),
        flex: 1,
    },
    '.MuiSwitch-root': {
        marginTop: theme.spacing(0.25),
    },
}));
